import React, { useContext, useState } from 'react';
import { ModalContext, IModalContext } from 'contexts/modal';
import { UserContext, IUserContext } from 'contexts/user';
import DetailsTable from 'components/details-table';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';
import { TryScrambleText } from 'utils/text-scrambler';
import { useTranslation } from 'next-i18next';
import { SiteNameSpace } from 'constants/locale';

import type Listing from 'data/listing';

interface Props {
  listing: Listing;
  isVisible: boolean;
  shouldScramble: boolean;
}

export default function Rooms({ listing, isVisible, shouldScramble }: Props) {
  const { isPrivate: listingIsPrivate, rooms, providerId, isSignInAndTermsOfUseRequired } = listing;
  const [units, setUnits] = useState('feet');
  const { openModal } = useContext(ModalContext) as IModalContext;
  const otherUnits = units === 'feet' ? 'metres' : 'feet';
  const { isAuthenticated } = useContext(UserContext) as IUserContext;
  const isPrivate = !isAuthenticated && listingIsPrivate;
  const { t } = useTranslation(SiteNameSpace.Modal);

  const openTermsModal = () => {
    if (isPrivate || (isSignInAndTermsOfUseRequired && !isVisible && !isAuthenticated)) {
      openModal('login-registration', { warningMessage: t('login-registration.form.signinRequiredWarning') });
    } else if (!isVisible) {
      openModal('terms-of-use', { providerId });
    }
  };

  return (
    <div className={styles.component}>
      <DetailsTable isPrivate={!isVisible}>
        <section className={styles['three-columns']}>
          <header>
            {!isVisible ?
              <a className="primary-link" onClick={() => openTermsModal()}>Show Details</a>
              :
              <p className={buildClassName('primary-link', styles['units-toggle'])} onClick={() => setUnits(otherUnits)}>
                Change to {otherUnits}
              </p>
            }
          </header>
          {rooms && <section>
            {rooms.map((room, index) => (
              <div className={styles.room} key={index}>
                <span>{room.type}:</span>
                <span>{room.level}</span>
                <span>
                  {TryScrambleText(room.size(units), shouldScramble)}
                </span>
              </div>
            ))}
          </section>}
        </section>
      </DetailsTable>
    </div>
  );
}
